import config from '../config'
import { authorizedFetch }  from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'
import { fetchBookings } from '../actions/locations'

export const SHOW_BOOKING_FORM = 'SHOW_BOOKING_FORM'
export const CLOSE_BOOKING_FORM = 'CLOSE_BOOKING_FORM'
export const UPDATE_BOOKING_FIELD = 'UPDATE_BOOKING_FIELD'
export const UPDATE_BOOKING = 'UPDATE_BOOKING'
export const UPDATE_BOOKING_SUCCEDED = 'UPDATE_BOOKING_SUCCEDED'
export const DELETE_BOOKING = 'DELETE_BOOKING'
export const DELETE_BOOKING_SUCCEDED = 'DELETE_BOOKING_SUCCEDED'

export const showUpdateBookingForm = (booking) => ({
  type: SHOW_BOOKING_FORM,
  booking: booking
})

export const closeBookingForm = () => ({
  type: CLOSE_BOOKING_FORM,
})

export const updateBookingField = (name, value) => ({
  type: UPDATE_BOOKING_FIELD,
  name: name,
  value: value
})

export const updateBooking = (booking) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'bookings/update',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({booking: booking})
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBookingSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const updateBookingSucceded = (location) => ({
  type: UPDATE_BOOKING_SUCCEDED,
  location: location
})

export const deleteBooking = (booking) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'bookings/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ booking : booking })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(function(json) {
        dispatch(deleteBookingSucceded(json))
        dispatch(fetchBookings(json))
      })
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const deleteBookingSucceded = (location) => ({
  type: DELETE_BOOKING_SUCCEDED,
  location: location
})



// WEBPACK FOOTER //
// ./src/actions/bookings.js